var SwitchSize;
(function (SwitchSize) {
  SwitchSize["Medium"] = 'medium';
  SwitchSize["Small"] = 'small';
})(SwitchSize || (SwitchSize = {}));
var SwitchVariant;
(function (SwitchVariant) {
  SwitchVariant["Immediate"] = 'immediate';
  SwitchVariant["Standard"] = 'standard';
})(SwitchVariant || (SwitchVariant = {}));
export { SwitchSize, SwitchVariant };